import React, { useEffect, useState, useContext } from "react";
import { Card, Form, CardBody, CardSubtitle, Container, Spinner } from "reactstrap"
import Dropzone from "react-dropzone";
import AWS from "aws-sdk";
import moment from "moment";
import ModalContext from "contexts/ModalContext";
import helper from "helpers/fn_helper";
import { UploadFile } from "services/api/module/Upload";
import axios from "axios";
import Spinners from "./Common/Spinner";
import fn_helper from "helpers/fn_helper";
import ImageComponent from "./ImageComponent";

const WebSrc = fn_helper.WEB.webSrc
const UploadFileAPI = ({
  label = "Dropzone",
  description = "description",
  errorDescription = '',
  required = false,
  onChange = () => console.log('onChange!'),
  prefixName = "broadcast",
  value = null,
  upload = "Image",
  typeUpload = "",
  widthSize = 0,
  heightSize = 0,
  bucketName = 'other',
}) => {
  // POPUP
  const { mAlert } = useContext(ModalContext);

  const [firstLoad, setFirstLoad] = useState(false);
  const [fileData, setFileData] = useState(null);
  const [fileURL, setFileURL] = useState(null);
  const [imageSize, setImageSize] = useState(null);
  const [loadingImage, setLoadingImage] = useState(false);
  const [fileType, setFileType] = useState(null);

  const [imageUploadBase64, setImageUploadBase64] = useState(null)

  async function handleAcceptedFiles(files) {
    console.log("🚀 ~ handleAcceptedFiles ~ files:", files)
    
    
    const _fileData = files[0]
    const tmpfilename = _fileData?.name ?? '.png'
    const typeSplit = `${tmpfilename}`.split('.')
    const typeFile = typeSplit[typeSplit.length - 1]

    const fileSize = _fileData.size
    const sizeInMB = fileSize / 1024 / 1024; // Convert bytes to MB

    let updateImageSize = '0x0'

    let CONF_FILE_TYPE = ['png','jpg','jpeg', 'svg']
    let CONF_FILE_SIZE = 10
    let JOIN = ', '

    // upload = "Image"
    if (upload == "Video") {
      CONF_FILE_TYPE = ['mp4']
      CONF_FILE_SIZE = 50
      JOIN = ''

      // setFileURL(URL.createObjectURL(files[0]));
      // setFileData(files[0]);
    }

    if (upload == "PDF") {
      CONF_FILE_TYPE = ['pdf']
      CONF_FILE_SIZE = 50
      JOIN = ''

      // setFileURL(URL.createObjectURL(files[0]));
      // setFileData(files[0]);
    }

    // upload = "Image"
    if (upload == "ImageVideo") {
      CONF_FILE_TYPE = ['png','jpg','jpeg', 'svg', 'mp4']
      CONF_FILE_SIZE = 50
      JOIN = ''

      // setFileURL(URL.createObjectURL(files[0]));
      // setFileData(files[0]);
    }


    if (CONF_FILE_TYPE.includes(typeFile)) {


      if (typeUpload == "ImageMap") {
        const { width, height } = await helper.FNFILE.getImageDimensions(_fileData)
        updateImageSize = `${width}x${height}`

        let minSize = 1024;
        console.log("🚀 ~ handleAcceptedFiles ~ width, height:", width, height)
        console.log("🚀 ~ handleAcceptedFiles ~ 1", width >= minSize)
        console.log("🚀 ~ handleAcceptedFiles ~ 2", height >= minSize)
        console.log("🚀 ~ handleAcceptedFiles ~ 3", width == height)
        if (!(width == widthSize && height == heightSize)) {
          mAlert.info({
            title: "Alert",
            subTitle: `File resolution ${widthSize} x ${heightSize}`,
            content: "",
            onClose: () => {
            },
          })
          return
        }
      }

      if (typeUpload == "ImageVideoMap") {
        if(['png','jpg','jpeg'].includes(typeFile)) {
          const { width, height } = await helper.FNFILE.getImageDimensions(_fileData)
          updateImageSize = `${width}x${height}`

          let minSize = 1024;
          console.log("🚀 ~ handleAcceptedFiles ~ width, height:", width, height)
          console.log("🚀 ~ handleAcceptedFiles ~ 1", width >= minSize)
          console.log("🚀 ~ handleAcceptedFiles ~ 2", height >= minSize)
          console.log("🚀 ~ handleAcceptedFiles ~ 3", width == height)
          if (!(width == widthSize && height == heightSize)) {
            mAlert.info({
              title: "Alert",
              subTitle: `File resolution ${widthSize} x ${heightSize}`,
              content: "",
              onClose: () => {
              },
            })
            return
          }
        }
      }

      if (sizeInMB <= CONF_FILE_SIZE) {
        // setFileURL(URL.createObjectURL(files[0]))
        setFileData(files[0])
        setImageSize(updateImageSize)
      } else {
        mAlert.info({
          title: "Alert",
          subTitle: `File size max ${CONF_FILE_SIZE} MB`,
          content: "",
          onClose: () => {
          },
        })
      }
    } else {
      let textError = errorDescription ? errorDescription : `File type ${CONF_FILE_TYPE.join(JOIN)} only`
      mAlert.info({
        title: "Alert",
        subTitle: `${textError}`,
        content: "",
        onClose: () => {
        },
      })
    }
    

    // formatBytes(file.size)
    // เซ็ตไว้ดูก่อน

    // files.map(file =>
    //   Object.assign(file, {
    //     preview: URL.createObjectURL(file),
    //     formattedSize: formatBytes(file.size),
    //   })
    // )
  }

  function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return "0 Bytes"
    const k = 1024
    const dm = decimals < 0 ? 0 : decimals
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]

    const i = Math.floor(Math.log(bytes) / Math.log(k))
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i]
  }

  const uploadFile = async (_fileData = {}) => {
    const tmpfilename = _fileData?.name ?? '.png'
    const tmpTypeFile = `${tmpfilename}`.split('.')
    const typeFile = tmpTypeFile[tmpTypeFile.length - 1]

    setFileType(typeFile)

    const timestamp = moment().unix();
    const fileName = `${prefixName}-${timestamp}.${typeFile}`

  
    // const FILE_LINK = HOST_FILE + `/` + fileName
    setLoadingImage(true)
    const FILE_LINK = await fetchUploadFile(_fileData, fileName, bucketName)
    setTimeout(() => setLoadingImage(false), 500)

    console.log("🚀 ~ uploadFile ~ FILE_LINK:", FILE_LINK)
    if (FILE_LINK) {
      if (['png','jpg','jpeg', 'svg'].includes(typeFile) && _fileData) {
        const reader = new FileReader();
        
        reader.onload = () => {
          // Convert file to base64
          const base64String = reader.result;
          // console.log("Base64 String:", base64String); // This is the base64 string
          setImageUploadBase64(base64String)
          onChange([FILE_LINK, imageSize, fileData, base64String])
        };
  
        reader.onerror = (error) => {
          console.error("Error converting file to base64:", error);
        };
  
        // Read file as data URL (base64)
        reader.readAsDataURL(_fileData);
      }
      else {
        onChange([FILE_LINK, imageSize, fileData])
      }
      
      
    }
  };

  async function fetchRetry(url, options = {}, retries = 3, backoff = 300) {
    /* 1 */
    const retryCodes = [408, 500, 502, 503, 504, 522, 524]
    return await fetch(url, options)
      .then(res => {
        if (res.ok){
          return true
        }
  
        if (retries > 0 && retryCodes.includes(res.status)) {
          setTimeout(async () => {
            /* 2 */
            return await fetchRetry(url, options, retries - 1, backoff * 2) /* 3 */
          }, backoff) /* 2 */
        } else {
          throw new Error(res)
        }
      })
      .catch(console.error)
  }

  const fetchUploadFile = async (selectedFile, fileName = '', _bucketName = '') => {
    const formData = new FormData();
    formData.append('file', selectedFile);

    return new Promise(async (resolve, reject) => {
      try {
        const response = await UploadFile({ formData: formData, bucketName: _bucketName, fileName: fileName })
        const resData = response.data
        if (resData.status === 201) {
          console.log('resData >>', resData)
          let fetching = fetchRetry(resData?.data?.url, 10, 500)
          if(fetching) {
            resolve(resData?.data?.url ?? null)
          }
        }
      } catch (e) {
          console.log(e)
          resolve(null)
          mAlert.info({
              title: "Alert",
              subTitle: "Something went wrong",
              content: "",
              onClose: () => {
              //  alert("onClose")
              },
          })
      }
    })
    
  }

  const onClearState = () => {
    setFileData(null)
    setFileURL(null)
    setFirstLoad(false)
    setFileType(null)
    onChange("")
  }

  useEffect(() => {
    if (fileData) {
      uploadFile(fileData)
    }
  }, [fileData])

  useEffect(() => {
    console.log("🚀 ~ useEffect ~ value:", value)
    if (value) {
      setFileURL(value)
      setFirstLoad(true)
    } else {
      onClearState()
    }
  }, [value])


  let acceptFile = {
    'image/*': ['.png','jpg','.jpeg'],
    // 'image/svg+xml': ['.svg'],
  }
  description = 'File type png, jpg, jpeg svg only, Max filesize 10 MB '
  if (upload == "Video") {
    acceptFile = { 'video/*': ['.mp4'] }
    description = 'File type mp4 only, Max file size 50 MB'
  }
  if (upload == "ImageVideo") {
    acceptFile = {
      'video/*': ['.mp4'],
      'image/*': ['.png','.jpg','.jpeg'],
      // 'image/svg+xml': ['.svg'],
    }
    description = 'File type .jpg .png  .mp4 only, Max file size 50 MB'
  }
  if (upload == "PDF") {
    acceptFile = { 'application/pdf': ['.pdf'] }
    description = 'File type pdf only, Max file size 50 MB'
  }
  if (typeUpload == "ImageMap") {  
    description = `File type png, jpg, jpeg only, Max filesize 10 MB`
    if (widthSize) {
      description += `, File resolution `
      description += `${widthSize} x `
    }
    if (heightSize) {
      description += `${heightSize}`
    }
  }
  if (typeUpload == "ImageVideoMap") {  
    description = `File type png, jpg, jpeg and mp4 only, Max filesize 50 MB`
    errorDescription = `File type png, jpg, jpeg and mp4 only`
    if (widthSize) {
      description += `, File resolution `
      description += `${widthSize} x `
    }
    if (heightSize) {
      description += `${heightSize}`
    }
  }




  return (
    <React.Fragment>
      <Card>
        <div>
          <h6 className="card-title">
            {label}
            {required ? <span className="t-require">*</span> : <></> }
          </h6>
          <CardSubtitle className="mb-3">
            {description}
          </CardSubtitle>
          <Form>
              {
                fileData || firstLoad ? (
                  <>
                      {
                        upload === "Image" ? (
                          <div className="dropzone bImageBox  d-flex justify-content-center align-items-center">
                            {
                              loadingImage
                              ? <Spinner color="primary" className='position-absolute top-50 start-50' />
                              : <ImageComponent data-dz-thumbnail="" src={imageUploadBase64 ?? WebSrc(fileURL)}/>
                            }
                            {/* {fileURL} <br/> */}
                            {/* {JSON.stringify(fileData)} */}
                          </div>
                        )
                        : 
                        upload === "Video" ? (
                          <div className="dropzone bImageBox">
                            <div className="bVideoUpload">
                              <div className="bx bx-video-recording bx-lg"></div>
                              <h4>Video File</h4>
                            </div>
                          </div>
                        )
                        : 
                        upload === "PDF" ? (
                          <div className="dropzone bImageBox">
                            <div className="bPDFUpload">
                              <div className="bx bxs-file-pdf bx-lg"></div>
                              <h4>PDF File</h4>
                            </div>
                          </div>
                        )
                        :
                        upload === "ImageVideo" ? (
                          <>
                            {fileURL && fileURL.indexOf('.mp4') > -1
                              ? <>
                                <div className="dropzone bImageBox">
                                  <div className="bVideoUpload">
                                    <div className="bx bx-video-recording bx-lg"></div>
                                    <h4>Video File</h4>
                                  </div>
                                </div>
                              </>
                              : loadingImage
                                ? <>
                                  <div className="dropzone bImageBox  d-flex justify-content-center align-items-center">
                                    <Spinner color="primary" className='position-absolute top-50 start-50' />
                                  </div>
                                </>
                                : <>
                                  <div className="dropzone bImageBox  d-flex justify-content-center align-items-center">
                                    <ImageComponent data-dz-thumbnail="" src={imageUploadBase64 ?? WebSrc(fileURL)}/>
                                  </div>
                                </>
                              
                            }
                          </>
                        )
                        : <>NULL</>

                      }
                    <div className="mt-4">
                        <button
                          type="button"
                          className="btn btn-danger "
                          onClick={onClearState}
                        >
                          Delete
                        </button>
                      </div>
                  </>
                ) :
                <>
                  <Dropzone
                    onDrop={acceptedFiles => {

                      handleAcceptedFiles(acceptedFiles)
                    }}
                    // accept= {{
                    //   'image/*': ['.png','jpg','.jpeg']
                    // }}
                    accept= {acceptFile}
                    multiple={false}
                  >
                    {({ getRootProps, getInputProps }) => (
                      <div className="dropzone">
                        <div
                          className="dz-message needsclick mt-2"
                          {...getRootProps()}
                        >
                          <input {...getInputProps()} />
                          <div className="mb-3">
                            <i className="display-4 text-muted bx bxs-cloud-upload" />
                          </div>
                          <h4>Drop {upload} file here or click to upload.</h4>
                        </div>
                      </div>
                    )}
                  </Dropzone>
                </>
              }
          </Form>

          {/* <div className="mt-4">
            <button
              type="button"
              className="btn btn-primary "
              onClick={() => uploadFile(fileData)}
            >
              Upload
            </button>
          </div> */}
          
         

        </div>
      </Card>
    </React.Fragment>
  )
}

export default UploadFileAPI
